import * as React from 'react';
export var StateContext = React.createContext({});
export var DispatchContext = React.createContext({});